import { useTranslation } from 'react-i18next';
import { orderStatusKeys } from '@/mocks/howItWorks';

export default function OrderProgress() {
  const { t } = useTranslation('howItWorks');

  return (
    <section className="w-full bg-ink-800 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="text-xs font-semibold text-warm-500 uppercase tracking-[0.2em] mb-3 block">
              {t('progress.label')}
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4">
              {t('progress.title')}
            </h2>
            <p className="text-sm md:text-base text-white/60 max-w-2xl mx-auto leading-relaxed">
              {t('progress.subtitle')}
            </p>
          </div>

          {/* Status flow */}
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
            {orderStatusKeys.map((key, index) => (
              <div
                key={key}
                className="flex items-center gap-3 p-4 bg-white/5 border border-white/10 rounded-lg"
              >
                <div
                  className={`w-8 h-8 shrink-0 rounded-full flex items-center justify-center text-sm font-bold ${
                    index === 0
                      ? 'bg-warm-500 text-white'
                      : 'bg-white/10 text-white/60'
                  }`}
                >
                  {index + 1}
                </div>
                <span className="text-sm text-white/80 leading-snug">{t(key)}</span>
              </div>
            ))}
          </div>

          <p className="text-xs md:text-sm text-white/40 text-center mt-8 max-w-3xl mx-auto leading-relaxed">
            {t('progress.note')}
          </p>
        </div>
      </div>
    </section>
  );
}